import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHeart = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 20.2033L4.01 11.87C3.30778 11.1683 2.8443 10.2634 2.6853 9.28351C2.5263 8.30363 2.67984 7.29856 3.12416 6.41085V6.41085C3.45921 5.74095 3.94864 5.16024 4.55212 4.71659C5.1556 4.27293 5.85586 3.97901 6.59521 3.85906C7.33456 3.7391 8.09182 3.79654 8.80462 4.02664C9.51741 4.25673 10.1653 4.65291 10.695 5.18251L12 6.48668L13.305 5.18251C13.8347 4.65291 14.4826 4.25673 15.1954 4.02664C15.9082 3.79654 16.6654 3.7391 17.4048 3.85906C18.1441 3.97901 18.8444 4.27293 19.4479 4.71659C20.0514 5.16024 20.5408 5.74095 20.8758 6.41085C21.3195 7.29821 21.4728 8.30269 21.314 9.28201C21.1552 10.2613 20.6923 11.1659 19.9908 11.8675L12 20.2033Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHeart.displayName = 'SvgHeart';
export default SvgHeart;
